import {DIContainer} from "@/utils/di-container";
import PayjpMock from "../../tests/_mocks/payjp-mock.js";
import PayJP from "@/libs/payjp";

if (process.env.NODE_ENV === 'testing') {
  DIContainer.payjp = new PayjpMock();
} else {
  DIContainer.payjp = new PayJP();
}
